import type { ReactNode } from 'react';
import { createContext, useContext, useLayoutEffect, useState } from 'react';

export const PanelRootElementContext = createContext<HTMLDivElement | null>(
  null,
);

export const PanelRootElementProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [value, setValue] = useState<HTMLDivElement | null>(null);
  useLayoutEffect(() => {
    const value = document.createElement('div');
    setValue(value);
    document.body.appendChild(value);
    return () => {
      if (value.parentNode) {
        value.parentNode.removeChild(value);
      }
    };
  }, []);
  return (
    <PanelRootElementContext.Provider value={value}>
      {children}
    </PanelRootElementContext.Provider>
  );
};

export const usePanelRootElement = () => {
  const rootElement = useContext(PanelRootElementContext);
  if (!rootElement) {
    throw new Error(
      'We did not find Panel context, you probably forgot to use Panel provider',
    );
  }
  return rootElement;
};
